import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useMemo } from "react";
import { Button, Enums } from "@envestnet/envreact-component-library";
import classnames from "classnames";
import { SecurityMethodTypes } from "./types";
import messages from "./messages";

type Props = {
  classes: any;
  methods: Array<SecurityMethodTypes>;
  formatMessage: FormatMessage;
  setSuccessMsgBoolean: Function;
  hasSuccessMsgSeen: boolean;
  clearGlobalUserInfo: Function;
  goToLoginScreen: Function;
};

export function SuccessMessagePlaceholder(props: Props) {
  const {
    classes,
    methods,
    formatMessage,
    setSuccessMsgBoolean,
    hasSuccessMsgSeen,
    clearGlobalUserInfo,
    goToLoginScreen,
  } = props;

  const hasAllMethodsConfigured = useMemo(
    () => methods.every((method) => method.enabled),
    [methods]
  );

  useEffect(
    () => () => {
      setSuccessMsgBoolean(true);
    },
    []
  );

  return (
    <>
      {!hasSuccessMsgSeen && !hasAllMethodsConfigured && (
        <div className={classes.registrationCompletedSection}>
          <div style={{ marginTop: 6 }}>
            <FontAwesomeIcon
              icon={faCircleCheck}
              size="lg"
              style={{ color: "#108043" }}
            />
          </div>
          <span className="header-text-font-family" style={{ marginTop: 3 }}>
            {formatMessage(messages.registrationSuccessMessage)}
          </span>
        </div>
      )}

      {hasAllMethodsConfigured && (
        <div className={classes.registrationCompletedSection}>
          <div style={{ marginTop: 6 }}>
            <FontAwesomeIcon
              icon={faCircleCheck}
              size="lg"
              style={{ color: "#108043" }}
            />
          </div>
          <span className="header-text-font-family" style={{ marginTop: 10 }}>
            {formatMessage(messages.configuredAllMethods)}
          </span>
        </div>
      )}
      <Button
        buttonStyle={Enums.ButtonStyle.Primary}
        buttonSize={Enums.ButtonSize.Regular}
        className={classnames(classes.gotoLoginButtonStyle, "no-border-radius")}
        name={formatMessage(messages.goToLoginButton)}
        onClick={() => {
          clearGlobalUserInfo();
          goToLoginScreen();
        }}
        aria-label="challenge question submit button"
      />
    </>
  );
}
